<template>
    <div class="af-jobview-widget af-jobview-widget-mobile">
        <div class="af-jobview-actions afu-px-5 afu-py-7 md:afu-p-8 afu-bg-white">
            <JobViewActionsMobile />
            <ShareJobMobile />
        </div>
    </div>
</template>

<script>
    import JobViewActionsMobile from './JobViewActionsMobile';
    import ShareJobMobile from './Actions/ShareJobMobile';

    export default {
        name: 'JobViewWidgetMobile',

        components: {
            JobViewActionsMobile,
            ShareJobMobile,
        },
    };
</script>
